import React, { createContext, FC, Fragment, useState } from "react";
import FlowioModal from "src/components/molecules/FlowioModal";
import ConfirmationButtons from "src/components/molecules/modals/ConfirmationModal/ConfirmationButtons/ConfirmationButtons";
import {
  ModalContentContainer,
  ModalContentText,
} from "./ModalContextProvider.styles";
import useHelpFunctions from "./useHelpFunctions";

interface ModalContextProps {
  children: React.ReactNode;
}

export type ModalData = {
  title: string;
  text: string;
  onConfirm: (value: unknown) => void;
  onCancel: () => void;
};

type ModalContextType = {
  modalData: null | ModalData;
  setModalData: React.Dispatch<React.SetStateAction<ModalData | null>>;
};

export const useModalContext = createContext<ModalContextType>({
  modalData: null,
  setModalData: (value: unknown) => null,
});

const ModalContextProvider: FC<ModalContextProps> = ({ children }) => {
  const [modalData, setModalData] = useState<null | ModalData>(null);
  const { getText } = useHelpFunctions(modalData);

  return (
    <Fragment>
      <useModalContext.Provider value={{ modalData, setModalData }}>
        {Boolean(modalData) && (
          <FlowioModal
            isOpen={Boolean(modalData)}
            title={modalData?.title ?? ""}
            toggle={() => {
              modalData?.onCancel();
            }}
          >
            <ModalContentText> {getText()} </ModalContentText>
            <ModalContentContainer>
              <ConfirmationButtons
                onAccept={() => modalData?.onConfirm("")}
                onDecline={() => modalData?.onCancel()}
              />
            </ModalContentContainer>
          </FlowioModal>
        )}
        {children}
      </useModalContext.Provider>
    </Fragment>
  );
};

export default ModalContextProvider;
